import { memo, useContext } from 'react';
import { NavigateFunction } from 'react-router';

import Button from '@/components/old/Button';

import ModalContext from '../../../contexts/Modal/ModalContext';
import { ROUTES } from '../../../router/config';
import { ModalBorderTopColor, ModalConstructor } from '../ModalConstructor';

import './DocumentDataMissingAlert.scss';

export interface DocumentDataMissingAlertProps {
  serviceName: string;
  navigate: NavigateFunction;
}

export const DocumentDataMissingAlert = memo(function DocumentDataMissingAlert({
  serviceName,
  navigate,
}: DocumentDataMissingAlertProps) {
  const { toggleModal } = useContext(ModalContext);

  return (
    <ModalConstructor
      modalBorderTopColor={ModalBorderTopColor.yellow}
      onCancel={() => {
        navigate(ROUTES.INTERNAL_SERVICES);
        toggleModal(false);
      }}
    >
      <div className="birthday-alert">
        <div className="birthday-alert__title">
          Для замовлення послуги &quot;{serviceName}&quot; необхідно заповнити всі обов&apos;язкові поля в розділі
          Профіль користувача.
        </div>

        <div className="birthday-alert__buttons-box">
          <Button
            isBorder={true}
            isMaxWidth={true}
            onClick={(): void => {
              navigate(ROUTES.INTERNAL_SERVICES);
              toggleModal(false);
            }}
          >
            До послуг
          </Button>
          <Button
            isMaxWidth={true}
            onClick={(): void => {
              navigate(ROUTES.USER.PROFILE);
              toggleModal(false);
            }}
          >
            Перейти у профіль
          </Button>
        </div>
      </div>
    </ModalConstructor>
  );
});
